<template>
 <div class="app-container">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="入库记录" name="first" v-if="rukuFLag">
          <ruku :productTypes="productTypes" :warehouseList="warehouseList" ref=ruku v-if="activeName=='first'&&warehouseFlag" > </ruku>
        </el-tab-pane>
        <el-tab-pane label="进仓记录" name="four1" v-if="jincangZYFlag">
          <jcrecordZY :productTypes="productTypes" :warehouseList="warehouseList" ref=jcrecord  v-if="activeName=='four1'&&warehouseFlag"></jcrecordZY>
        </el-tab-pane>
        <el-tab-pane label="出库记录" name="two">
          <chuku :productTypes="productTypes" :warehouseList="warehouseList" ref=chuku v-if="activeName=='two'&&warehouseFlag"> </chuku>
        </el-tab-pane>
        <el-tab-pane label="转货记录" name="three">
          <zhuanhuo :productTypes="productTypes" :warehouseList="warehouseList" ref=zhuanhuo v-if="activeName=='three'&&warehouseFlag"> </zhuanhuo>
        </el-tab-pane>
        <el-tab-pane label="进仓记录" name="four" v-if="jincangFlag">
          <jcrecord :productTypes="productTypes" :warehouseList="warehouseList" ref=jcrecord v-if="activeName=='four'&&warehouseFlag"></jcrecord>
        </el-tab-pane>
      </el-tabs>
 </div>
</template>

<script>
import ruku from '@/views/soc-stock-cosco/goodsRecord/ruku.vue'
import chuku from '@/views/soc-stock-cosco/goodsRecord/chuku.vue'
import zhuanhuo from '@/views/soc-stock-cosco/goodsRecord/zhuanhuo.vue'
import jcrecord from '@/views/soc-stock-cosco/goodsRecord/jcrecord.vue'
import jcrecordZY from '@/views/soc-stock-cosco/goodsRecord/jcrecordZY.vue'
import { getDictionaryAll, getOrganizationNameList, selectCommonDictionary } from '@/api/soc-stock-cosco'
import { getAttributeA } from '@/utils/getButton'
export default {
  components: {
    ruku, chuku, zhuanhuo, jcrecord, jcrecordZY
  },
  data () {
    return {
      activeName: 'first',
      productTypes: [],
      warehouseList: [],
      oneCustomerTaxId: localStorage.getItem('tenantTaxpayerNumber'),
      warehouseFlag: null,
      warehouse: null,
      jincangFlag: false, // 判断进建发仓记录是否展示
      rukuFLag: true,
      jincangZYFlag: false

    }
  },
  created () {
    // 获取货物类型
    getDictionaryAll({ groupNo: 'thread_product_type' }).then(res => {
      this.productTypes = res
      this.productTypes.unshift({ show_name: '请选择', item_no: '' })
    })
    // 获取仓库名称
    if (localStorage.getItem('isCutCrm3') == 1) {
      this.warehouseList = [{
        relTenantName: localStorage.getItem('createTenantName'),
        relTenantCode: localStorage.getItem('createTenantCode')
      }]
      this.warehouseFlag = true
      getAttributeA('ARRwarehousingRecord,ARRjcrecordZY,ARRruku', this.warehouseList[0].relTenantCode).then(res => {
        this.jincangFlag = res[0] === '0'
        this.jincangZYFlag = res[1] === '0'
        this.rukuFLag = res[2] === '0'
      })
    } else {
      getOrganizationNameList({
        userCode: localStorage.getItem('userCode'),
        tenantCode: localStorage.getItem('tenantCode')
      }).then(res => {
        this.warehouseFlag = true
        if (res.length > 0) {
          this.warehouseList = res
        }
      })
    }
  },
  mounted () {
  },
  methods: {
    handleClick () {

    }
  }
}
</script>

<style scoped lang='less'>
.searchBtnBox {
  margin-left: 10px;
}
.inpBox .el-date-editor{
  width: 350px!important;
}
.imgBox{
  display: flex;
  .item{
    display: flex;
     width: 50%;
     justify-content: space-around;
  }
}
/deep/ .checkboxBox{
  display: flex;
  label{
    flex-shrink: 0;
  }
  .el-checkbox-group{
    width:250px ;
  }
}
/deep/.el-tabs__item{
  padding-left: 10px!important;
}
// /deep/.el-tabs__active-bar{
//   padding: 0 10px;
//   margin-left: -10px;
// }
    /deep/.el-tabs__header{
  margin-bottom: 0;
}
</style>
